import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../config";
import {
  Building2, User, Lock
} from "lucide-react";
import "./Settings.css";
import Navbar from "../components/Navbar";

function Settings() {
  const navigate = useNavigate();

  // Initial State
  const [hotelData, setHotelData] = useState({
    name: "",
    contact: "",
    address: "",
    username: "",
    email: "",
    password: "" 
  });

  const [newPassword, setNewPassword] = useState("");
  const [currentPassInput, setCurrentPassInput] = useState("");

  // 1. Fetch data from MySQL on mount
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const userId = localStorage.getItem("user_id") || 0;
        const res = await axios.get(`${API_BASE_URL}/settings.php?user_id=${userId}`);
        if (res.data) {
          setHotelData(res.data);
        }
      } catch (err) {
        console.error("Failed to load settings from database:", err);
      }
    };
    fetchSettings();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    
    // 2. Password Change Logic
    let updatedPassword = hotelData.password;

    if (newPassword.trim() !== "") {
      // Compare user input with the password fetched from the database
      if (currentPassInput !== hotelData.password) {
        alert("Verification failed!\nTyped: [" + currentPassInput + "]\nDatabase has: [" + hotelData.password + "]");
        return;
      }
      updatedPassword = newPassword;
    }

    const userId = localStorage.getItem("user_id") || 0;
    const updatedData = { 
      ...hotelData, 
      password: updatedPassword,
      user_id: userId
    };

    try {
      // 3. Save to Database via PHP
      const res = await axios.post(`${API_BASE_URL}/settings.php`, updatedData);
      
      if (res.data.status === "success") {
        setHotelData(updatedData);
        setNewPassword("");
        setCurrentPassInput("");
        alert("Settings updated successfully in database!");
      } else {
        alert("Error updating settings: " + res.data.message);
      }
    } catch (err) {
      console.error("Save error:", err);
      alert("Server error. Please check if XAMPP is running.");
    }
  };

  return (
    <div className="page-layout">
      <Navbar />
      <main className="main-content">
        <div className="settings-container">

        <header className="page-header">
          <div className="header-titles">
            <h1 className="serif-title">Settings</h1>
            <p className="subtitle">Manage hotel database settings</p>
          </div>
        </header>

          <div className="settings-card">
            <form onSubmit={handleSave}>

              {/* Hotel Details Section */}
              <div className="settings-section">
                <div className="section-title">
                  <Building2 size={18} className="icon-orange"/>
                  Hotel Details
                </div>
                <div className="input-row">
                  <div className="input-box">
                    <label>Hotel Name</label>
                    <input
                      type="text"
                      placeholder="e.g. Dine Spark"
                      value={hotelData.name}
                      onChange={(e)=>setHotelData({...hotelData, name:e.target.value})}
                    />
                  </div>
                  <div className="input-box">
                    <label>Contact Number</label>
                    <input
                      type="text"
                      placeholder="+91 98765 43210"
                      value={hotelData.contact}
                      onChange={(e)=>setHotelData({...hotelData, contact:e.target.value})}
                    />
                  </div>
                </div>
                <div className="input-box full-width">
                  <label>Address</label>
                  <input
                    type="text"
                    placeholder="123 Main Street, City"
                    value={hotelData.address}
                    onChange={(e)=>setHotelData({...hotelData, address:e.target.value})}
                  />
                </div>
              </div>

              {/* Admin Account Section */}
              <div className="settings-section">
                <div className="section-title">
                  <User size={18} className="icon-orange"/>
                  Admin Account
                </div>
                <div className="input-row">
                  <div className="input-box">
                    <label>Username</label>
                    <input
                      type="text"
                      placeholder="admin"
                      value={hotelData.username}
                      onChange={(e)=>setHotelData({...hotelData, username:e.target.value})}
                    />
                  </div>
                  <div className="input-box">
                    <label>Email</label>
                    <input
                      type="email"
                      placeholder="admin@dinespark.com"
                      value={hotelData.email}
                      onChange={(e)=>setHotelData({...hotelData, email:e.target.value})}
                    />
                  </div>
                </div>
              </div>

              {/* Change Password Section */}
              <div className="settings-section">
                <div className="section-title">
                  <Lock size={18} className="icon-orange"/>
                  Change Password
                </div>
                <div className="input-row">
                  <div className="input-box">
                    <label>Current Password</label>
                    <input 
                      type="password"
                      placeholder="Verify current password"
                      value={currentPassInput}
                      onChange={(e) => setCurrentPassInput(e.target.value)}
                    />
                  </div>
                  <div className="input-box">
                    <label>New Password</label>
                    <input 
                      type="password"
                      placeholder="Enter new password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="form-footer">
                <button type="submit" className="btn-save">Save Changes</button>
              </div>

            </form>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Settings;